import { GetTotalPassList } from "../../reducers/totalPass";

export interface TotalPassListStore extends GetTotalPassList {}

export const totalPassListStore: (state) => TotalPassListStore = state => {
  const { totalPass } = state;
  return {
    totalPassList: totalPass.totalPassList,
    gettingTotalPassList: totalPass.gettingTotalPassList,
    gettingTotalPassListError: totalPass.gettingTotalPassListError
  };
};
